export default __webpack_public_path__ + "static/media/dg10.64340579.jpg";